import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';

// Copies de l'API gardées par l'ancien service hors-ligne (jusqu'au 20/10/2026) : effacées, elles pouvaient
// appartenir à une autre société ou à un autre compte.
if (typeof caches !== 'undefined') void caches.delete('simgroup-api-cache').catch(() => undefined);
import App from './App';
import './index.css';

/**
 * Recharge la page quand une nouvelle version prend la main.
 *
 * Le service worker precache index.html. Apres un deploiement, il sert donc
 * l'ancienne page depuis son cache pendant qu'il installe la nouvelle version
 * en arriere-plan : il fallait DEUX chargements pour voir un changement, et
 * l'utilisateur croyait la livraison ratee. Constate le 21/09/2026 — l'entree
 * « Patrimoine » etait bien dans le bundle servi, invisible a l'ecran.
 *
 * nginx est pourtant regle correctement (no-store sur index.html) : c'est le
 * service worker qui court-circuite le reseau. La correction se fait donc ici.
 */
if ('serviceWorker' in navigator) {
  // Au tout premier passage, aucun service worker ne controle encore la page ;
  // clientsClaim declenche alors controllerchange lui aussi. Recharger dans ce
  // cas provoquerait une boucle de rechargement a la premiere visite.
  const dejaControlee = !!navigator.serviceWorker.controller;
  let rechargementEnCours = false;

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (!dejaControlee || rechargementEnCours) return;
    rechargementEnCours = true;
    window.location.reload();
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);
